import { Redirect, useLocation, useParams } from 'react-router-dom';
import {
    clearSsoConnection,
    getSsoConnection,
    setSsoConnection,
} from '@/utils/auth/ssoPreference';
import { useEffect, useRef } from 'react';
import AuthError from './AuthError';
import LoadingScreen from './LoadingScreen';
import { useAuth0 } from '@auth0/auth0-react';

function Login() {
    const { connection } = useParams();
    const { search } = useLocation();
    const { isAuthenticated, loginWithRedirect, isLoading, error } = useAuth0();
    const hasInitiatedLogin = useRef(false);

    useEffect(() => {
        if (!hasInitiatedLogin.current && !isLoading && !isAuthenticated) {
            hasInitiatedLogin.current = true;

            const shouldReset = new URLSearchParams(search).has('reset');
            if (shouldReset) {
                clearSsoConnection();
            }

            if (connection) {
                setSsoConnection(connection);
            }

            const effectiveConnection =
                connection || (!shouldReset && getSsoConnection()) || null;

            const loginOptions = {};
            if (effectiveConnection) {
                loginOptions.connection = effectiveConnection;
            }
            loginWithRedirect(loginOptions);
        }
    }, [isAuthenticated, isLoading, loginWithRedirect, connection, search]);

    if (isLoading) {
        return <LoadingScreen text="Loading..." />;
    }

    if (error) {
        return <AuthError error={error} />;
    }

    if (!isLoading && !isAuthenticated) {
        return <LoadingScreen text="Redirecting..." />;
    }

    return <Redirect to="/" />;
}

export default Login;
